import { createContext, useContext, useState } from "react";
import { useFx } from "@/context/FxContext";

const CurrencyContext = createContext(null);

const SYMBOL = { TRY: "₺", USD: "$", EUR: "€" };

export function CurrencyProvider({ children }) {
  const [display, setDisplay] = useState("TRY");
  const { rates } = useFx();

  const fromTry = (tryAmount) => (Number(tryAmount) || 0) / (rates[display] || 1);
  const toTry = (amount, currency) => Number(amount) * (rates[currency || "TRY"] || 1);

  const formatFromTry = (tryAmount) => {
    const v = fromTry(tryAmount);
    return `${SYMBOL[display]}${v.toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const formatAmount = (amount, currency) => {
    const c = currency || "TRY";
    return `${SYMBOL[c]}${Number(amount).toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  return (
    <CurrencyContext.Provider
      value={{ display, setDisplay, formatFromTry, formatAmount, toTry, SYMBOL, rates }}
    >
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
